/* eslint-disable */
import React from "react";
import { User, Package, CreditCard, CheckCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

const StepIndicator = ({ store, currentStep, isOfferFirst }) => {
  const { t } = useTranslation();
  const steps = isOfferFirst
    ? [
        {
          id: 1,
          label: t("formPreview.stepIndicator.steps.additionalInfo"),
          icon: Package,
        },
        {
          id: 2,
          label: t("formPreview.stepIndicator.steps.personalInfo"),
          icon: User,
        },

        {
          id: 3,
          label: t("formPreview.stepIndicator.steps.confirmOrder"),
          icon: CreditCard,
        },
      ]
    : [
        {
          id: 1,
          label: t("formPreview.stepIndicator.steps.personalInfo"),
          icon: User,
        },
        {
          id: 2,
          label: t("formPreview.stepIndicator.steps.additionalInfo"),
          icon: Package,
        },
        {
          id: 3,
          label: t("formPreview.stepIndicator.steps.confirmOrder"),
          icon: CreditCard,
        },
      ];

  const circleSize = 40;
  const lineWidth = 24;

  return (
    <div className="mb-6">
      <div className="flex items-center justify-center gap-6">
        {steps.map((step, idx) => (
          <div key={step.id} className="relative flex flex-col items-center">
            {idx < steps.length - 1 && (
              <div
                className="absolute left-full top-1/2 h-px bg-gray-200"
                style={{
                  width: lineWidth,
                  transform: "translateY(-50%)",
                }}
              >
                <div
                  className="h-full bg-current transition-all duration-300"
                  style={{
                    width: currentStep > step.id ? "100%" : "0%",
                    backgroundColor: store.color1,
                  }}
                />
              </div>
            )}

            <div
              className={`relative flex items-center justify-center rounded-full transition-transform duration-300
                ${
                  currentStep >= step.id
                    ? "scale-105 shadow-md text-white"
                    : "bg-gray-100 border border-gray-200 text-gray-400"
                }
              `}
              style={{
                width: circleSize,
                height: circleSize,
                backgroundColor:
                  currentStep >= step.id ? store.color1 : undefined,
                boxShadow:
                  currentStep >= step.id
                    ? `0 6px 15px ${store.color1}40`
                    : undefined,
              }}
            >
              {currentStep >= step.id && (
                <div
                  className="absolute inset-0 rounded-full"
                  style={{
                    background: `linear-gradient(135deg, ${store.color1}, ${store.color2})`,
                  }}
                />
              )}

              <div className="relative z-10">
                {currentStep > step.id ? (
                  <CheckCircle className="w-5 h-5" />
                ) : (
                  <step.icon className="w-5 h-5" />
                )}
              </div>
            </div>

            <span
              className={`mt-1 text-xs font-medium transition-colors duration-300
                ${
                  currentStep >= step.id
                    ? "text-gray-800 dark:text-gray-300"
                    : "text-gray-400 dark:text-gray-500"
                }
              `}
            >
              {step.label}
            </span>

            {currentStep === step.id && (
              <div
                className="absolute -bottom-1 w-1 h-1 rounded-full"
                style={{ backgroundColor: store.color1 }}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default StepIndicator;
